import moment, { MomentInput } from "moment-timezone"

export const dateWithTime = (timestamp: MomentInput | null) => timestamp ? moment(timestamp).format('YYYY-MM-DD HH:mm') : ""
